import { getEnv } from "./env";
import * as _ from "lodash";
const EMPTY_IMAGE = "/img/chat/empty.jpg";

const cdnUrl = getEnv("REACT_APP_CDN_URL");

export const getImageUrl = (url) => {
  if (!url) {
    return EMPTY_IMAGE;
  }

  if (_.startsWith(url, "/img") || _.startsWith(url, "data:")) {
    return url;
  }

  return `${cdnUrl}/${url}`;
};
